import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCopy = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 20,
	viewBox: "0 0 18 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5 0C4.44772 0 4 0.447715 4 1C4 1.55228 4.44772 2 5 2H13C14.6569 2 16 3.34315 16 5V13C16 13.5523 16.4477 14 17 14C17.5523 14 18 13.5523 18 13V5C18 2.23858 15.7614 0 13 0H5ZM3 4C1.34315 4 0 5.34315 0 7V17C0 18.6569 1.34315 20 3 20H11C12.6569 20 14 18.6569 14 17V7C14 5.34315 12.6569 4 11 4H3ZM2 7C2 6.44772 2.44772 6 3 6H11C11.5523 6 12 6.44772 12 7V17C12 17.5523 11.5523 18 11 18H3C2.44772 18 2 17.5523 2 17V7Z",
		fill: "currentColor"
	})
});
export default SvgCopy;
